// VeeValidator
import Vue from 'vue'
import VeeValidate, { Validator } from "vee-validate"
import * as es from 'vee-validate/dist/locale/es'

Validator.localize('es', es)
Vue.directive('validate', VeeValidate)

Vue.use(VeeValidate, {locale: 'es'})